export default "__VITE_ASSET__BWhuqENA__"